import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import { truncate } from 'lodash/string';

class FeaturedOrgBannerCard extends Component {
  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {

  }

  componentWillMount() {

  }


  componentDidMount() {

  }

  render() {
    let imgPath = '';
    let browser = this.props.browser;

    let title = this.props.title;
    let tag = this.props.tag;

    if (browser.greaterThan.tablet) {
      imgPath = '/images/home/banners/desktop/';
    } else {
      imgPath = '/images/home/banners/mobile/';
    }

    let imgUrl = imgPath + this.props.imgUrl;

    let btnText = this.props.btnText;
    let btnUrl = this.props.btnUrl;
    let learnMoreUrl = this.props.learnMoreUrl;
    let learnMoreText = this.props.learnMoreText;
    let slug = this.props.slug;
    let isExternalUrl = this.props.isExternalUrl;


    let reg = '';
    let linkCode = '';
    let learnMoreCode = '';

    // default link
    if (isExternalUrl) {
      linkCode = <a target="_blank" href={btnUrl}
        className="homeBannerFeaturedOrgs-btn button button-wrap">{btnText}</a>;

        learnMoreCode = <a target="_blank" href={learnMoreUrl}
          className="homeBannerFeaturedOrgs-btn button button-wrap">{learnMoreText}</a>;
    } else {
      linkCode = <Link to={btnUrl}
        className="homeBannerFeaturedOrgs-btn button button-wrap">{btnText}</Link>;

        learnMoreCode = <Link to={learnMoreUrl}
          className="homeBannerFeaturedOrgs-btn button button-wrap">{learnMoreText}</Link>;
    }


    if (slug == 'girls-festival') {
      reg = <sup className="regMark-small">&nbsp;</sup>
    } else if (slug == 'bfw') {
        reg = <sup className="bfw-tm-small">&trade;</sup>
    } else if (slug == 'directory') {
        reg = <sup className="bfw-tm-small">&nbsp;</sup>
        linkCode = <button onClick={(e) => {e.preventDefault(); this.props.openSignupFormRequest() }}
          className="homeBannerFeaturedOrgs-btn button button-wrap">Sign up</button>
    }

    let CTA = '';
    CTA = <div className="homeBannerFeaturedOrgs-ctaInnerWrapper">
      <div className="homeBannerFeaturedOrgs-cta">
        <div className="homeBannerFeaturedOrgs-ctaHeader">{title}{reg}</div>
        <div className="homeBannerFeaturedOrgs-ctaCopy">
          {tag}
        </div>
        <div className="homeBannerFeaturedOrgs-ctaBtnWrapper">
          <div className="btnWrapper join">
            {linkCode}
          </div>

          <div className="btnWrapper homeBannerFeaturedOrgs-btnLearnMore">{learnMoreCode}</div>
        </div>
      </div>
    </div>


    // Compute the height ratio of the banner based on browser width.
    let imgWrapperWidth = '';
    let imgWrapperHeight = '';

    if (browser.greaterThan.desktop) {
      imgWrapperWidth = '1190px';
      imgWrapperHeight = '453px';
    } else if (browser.greaterThan.tabletLandscape) {
      imgWrapperWidth = '100%';
      imgWrapperHeight = browser.width * .378;

    } else if (browser.greaterThan.tablet) {
      imgWrapperWidth = '100%';
      imgWrapperHeight = browser.width * .378;

    } else if (browser.greaterThan.phablet) {
      imgWrapperWidth = '100%';
      imgWrapperHeight = browser.width * .6879;

    } else {
      imgWrapperWidth = '100%';
      imgWrapperHeight = browser.width * .6879;
    }



    return(
      <main>
        <div className="bannerCard-outerWrapper">
        <div className="bannerCard-CTAWrapper">
          {CTA}
        </div>
        <div className="homeBannerFeaturedOrgs-cardWrapper">

          <div style={{width: imgWrapperWidth, height: imgWrapperHeight, overflow: 'hidden', position: 'relative'}} className="homeBannerFeaturedOrgs-cardImgWrapperOuter">


            <div style={{backgroundImage: 'url(' + imgUrl + ')', backgroundSize: 'cover'}} className="homeBannerFeaturedOrgs-cardImgWrapper"></div>
          </div>

        </div>
        </div>


      </main>

    )
  }

}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps
)(FeaturedOrgBannerCard);



// WEBPACK FOOTER //
// ./src/components/homeBanner2/BannerCard.jsx